export default __webpack_public_path__ + "static/media/innovative-claster.1aff9685.png";